import { ITimeFrameObject } from '../editing-directive/i-time-frame-object';
import { ContentControlledEventActionEnum } from '../enums/content-controlled-event-action.enum';
import { ContentControlledMediaTypeEnum } from '../enums/content-controlled-media-type.enum';
import { ContentControlledKeyframe } from '../keyframe/content-controlled-keyframe';
import { ContentControlledEditingDirective } from '../editing-directive/content-controlled-editing-directive';
import { ContentControlledReportableEventBy } from './content-controlled-reportable-event-by.enum';

export class ContentControlledReportableEvent implements ITimeFrameObject {
  constructor(
    public id: number,
    public analyzeType: string,
    public eventType: string,
    public reportedBy: ContentControlledReportableEventBy,
    private mediaType: ContentControlledMediaTypeEnum = ContentControlledMediaTypeEnum.External,
    public title: string,
    public startsAtMs: number,
    public endsAtMs: number,
    public keyframes: Array<ContentControlledKeyframe> = [],
    public startFrame?: string,
    public endFrame?: string,
  ) {}
  public toEventDirective(_frameRate: number) {
    const kf = [...this.keyframes];
    return new ContentControlledEditingDirective(
      this.id,
      this.mediaType,
      this.startsAtMs,
      this.endsAtMs,
      this.title,
      false,
      false,
      ContentControlledEventActionEnum.Empty,
      kf,
      this.startFrame,
      this.endFrame,
      undefined,
      undefined,
      undefined,
      undefined,
    );
  }
}
